<div class="card">
	<p-dataView
		layout="grid"
		[value]="rankingMedias"
		[paginator]="false"
		filterBy="name"
	>
		<!-- Header -->
		<ng-template pTemplate="header">
			<div class="flex align-items-center justify-content-between">
				<strong>Ranking de Medias por Reproducciones</strong>
				<p-dataViewLayoutOptions></p-dataViewLayoutOptions>
			</div>
		</ng-template>

		<!-- Vista en lista -->
		<ng-template let-media let-i="index" pTemplate="listItem">
			<div class="p-col-12">
				<div class="card ranking-card ranking-list-row">
					<!-- Ranking -->
					<div class="ranking-badge-list">#{{ getRankingIndex(media.id) }}</div>

					<div class="ranking-row">
						<!-- Nombre -->
						<div class="ranking-col ranking-name">
							<div class="media-title">
								{{ media.name }}
							</div>
							<small>ID: {{ media.id }}</small>
						</div>

						<!-- KPI principal -->
						<div class="ranking-col ranking-kpi-main">
							<i class="pi pi-eye"></i>
							<span class="ranking-value">
								{{ media.reproducciones | number }}
							</span>
							<small>Reproducciones</small>
						</div>

						<!-- Duración -->
						<div class="ranking-col">
							<i class="pi pi-clock"></i>
							<span class="ranking-value">
								{{ media.duration_seconds }} s
							</span>
							<small>Duración</small>
						</div>

						<!-- Tiempo total -->
						<div class="ranking-col">
							<i class="pi pi-stopwatch"></i>
							<span class="ranking-value">
								{{ media.segundos_reproducidos | number }} s
							</span>
							<small>Tiempo total</small>
						</div>
					</div>
				</div>
			</div>
		</ng-template>

		<!-- Vista en grid -->
		<ng-template let-media let-i="index" pTemplate="gridItem">
			<div class="p-col-12 p-md-4 p-lg-3">
				<div class="card ranking-card">
					<!-- Ranking -->
					<div class="ranking-badge-grid">#{{ getRankingIndex(media.id) }}</div>

					<!-- Nombre -->
					<div class="media-title text-center">
						{{ media.name }}
					</div>

					<!-- KPI principal -->
					<div class="kpi-main text-center">
						<i class="pi pi-eye"></i>
						<div class="kpi-value">
							{{ media.reproducciones | number }}
						</div>
						<div class="kpi-label">Reproducciones</div>
					</div>

					<!-- Métricas secundarias -->
					<div class="grid kpi-secondary text-center">
						<div class="">
							<i class="pi pi-clock"></i>
							<div class="kpi-secondary-value">
								{{ media.duration_seconds }} s
							</div>
							<small>Duración</small>
						</div>
						<div class="">
							<i class="pi pi-stopwatch"></i>
							<div class="kpi-secondary-value">
								{{ media.segundos_reproducidos | number }}
							</div>
							<small>Tiempo total</small>
						</div>
					</div>
				</div>
			</div>
		</ng-template>
	</p-dataView>
</div>
